import React, { Component, PureComponent  } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { destructServerErrors, hasErrors, allErrors } from '../../helpers/error';
import { updateProfileRequest, updateLocaleRequest } from '../../actions/profile';
import FormError from '../partials/FormError';
import __ from '../../helpers/translation';

const propTypes = {
  auth: PropTypes.object.isRequired,
  updateProfileRequest: PropTypes.func.isRequired,
  updateLocaleRequest: PropTypes.func.isRequired,
};

class Account extends PureComponent {

    constructor (props) {
      super(props);
      this.state = {
        'email': props.auth.user.email,
        'language': props.auth.user.language,
        '_method': 'PATCH',
        'password': '',
        'password_confirmation': '',
        'errors': '',
        'updateMessage': ''
      }
    }

    handleSubmit (e) {
      e.preventDefault();
      this.props.updateProfileRequest({ ...this.state, user: this.props.auth.user })
            .then(data => {
              this.setState({ 
                'updateMessage': data.status,
                'password': '',
                'password_confirmation': ''
              });
              if(this.props.auth.user.language != window.App.locale){
                this.props.updateLocaleRequest({user: this.props.auth.user, language: this.props.auth.user.language});
              }
            })
            .catch(error => this.setState({ 
                errors: destructServerErrors(error) 
            }));
    }

    handleInputChange (e) {
      this.setState({
        [e.target.name]: e.target.value,
        errors: {
          ...this.state.errors,
          ...{ [e.target.name]: '' }
        },
        'updateMessage': ''
      });
    }

    languages(){
      let languages = [
        {'code': 'gb', 'icon': 'assets/media/icons/svg/Flags/gb.svg'},
        {'code': 'nl', 'icon': 'assets/media/icons/svg/Flags/nl.svg'},
        {'code': 'gr', 'icon': 'assets/media/icons/svg/Flags/gr.svg'}
      ];

      return languages.filter(function(lang){
        return window.App.localeList.indexOf(lang.code) > -1;
      });
    }

    componentDidUpdate(){
      /*if(!this.props.auth.authenticated){
          console.log('not auth');
      } else {
        console.log('authenticated');
      }*/
    }

    render () {
        return (

            <div className="md-box p-5">
                { this.props.auth.user && 
                    (
                    <h1 className="fw-600 mb-4">{ this.props.auth.user.name }</h1>
                    )
                }
                <form autoComplete="off" onSubmit={e => this.handleSubmit(e)} method="POST">
                    {
                      this.state.updateMessage !== '' && (
                      <div className="alert alert-info font-size-18 font-weight-bold" role="alert">
                        {this.state.updateMessage}
                      </div>
                      )
                    }
                    {
                        hasErrors(this.state.errors) && (
                            <div className="mt-3">
                              <FormError>{allErrors(this.state.errors).join('<br/>')}</FormError>
                            </div>
                        )
                    }
                    <p className="mb-3">{ __('app.profile.change_account_info') }</p>
                    <div className="form-label-group">
                        <input name="email" value={this.state.email} onChange={e => this.handleInputChange(e)} type="text" id="inputEmail" className="form-control" placeholder={ __('app.profile.account_email') } />
                        <label htmlFor="inputEmail">{ __('app.profile.account_email') }</label>
                    </div>
                    <div className="form-label-group">
                        <input name="password" value={this.state.password} autoComplete="new-password" onChange={e => this.handleInputChange(e)} type="password" id="inputPassword" className="form-control" placeholder={ __('app.profile.account_password') } />
                        <label htmlFor="inputPassword">{ __('app.profile.account_password') }</label>
                    </div>
                    <div className="form-label-group">
                        <input name="password_confirmation" value={this.state.password_confirmation} onChange={e => this.handleInputChange(e)} type="password" id="inputPassword2" className="form-control" placeholder={ __('app.profile.account_password_confirm') } />
                        <label htmlFor="inputPassword2">{ __('app.profile.account_password_confirm') }</label>
                    </div>
                    <p className="mt-3">{ __('app.profile.account_language') }</p>
                    <div className="form-label image-option">
                        {this.languages().map((lang, index) => {
                            return <label key={lang.code} className="mr-3">
                                  <input checked={ this.state.language == lang.code} name="language" value={lang.code} onChange={e => this.handleInputChange(e)} type="radio" />
                                  <img src={window.App.baseUrl + lang.icon} alt={lang.code} className="" />
                              </label>
                        })}
                    </div>
                    <button type="submit" className="btn btn-success d-block w-100 mt-4">{ __('app.profile.account_save') }</button>
                </form>
            </div>

        )
    }
}

Account.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = {
  updateProfileRequest,
  updateLocaleRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Account));